'use strict';

import { Buildings, isMobile, projectMode, settingsData, threeJsVariables } from '../../settings';
import {
    autoRotateTimerAction,
    getCurrentCameraDistance, isOrbitControlsEnabled,
    setMinAndMaxControlsDistance,
} from './orbitControls';
import { createHtmlElement, userPrevent } from '../../functions';
import {getHighlights} from '../threejs/autoSelectionBoxes'
import { Vector3, Box3 } from 'three';

let timerID, touchStartX, touchStartY;

export function zoomButtonsControl(parent) {
    if (isMobile) {
        return;
    }

    const mainWrapper = createHtmlElement(parent, '', 'div', ['zoom__controls']);
    const decreaseBtn = createHtmlElement(mainWrapper, '', 'button', ['zoom__controls__btn', 'icon-minus']);
    decreaseBtn.dataset.zoomBtn = 'decrease';
    const increaseBtn = createHtmlElement(mainWrapper, '', 'button', ['zoom__controls__btn', 'icon-plus']);
    increaseBtn.dataset.zoomBtn = 'increase';

    mainWrapper.addEventListener('click', zoomControlsHandler);
    mainWrapper.addEventListener('mousedown', holdingInButton);
    mainWrapper.addEventListener('mouseleave', holdingOutButton);
    mainWrapper.addEventListener('mouseup', holdingOutButton);

    mainWrapper.addEventListener('touchstart', holdingInButton);
    mainWrapper.addEventListener('touchmove', holdingOutButton);
    mainWrapper.addEventListener('touchend', holdingOutButton);
}

function holdingInButton(e) {
    // if (settingsData.tourIsActive) {
    //     stopCameraTour();
    //     return;
    // }

    if (!isOrbitControlsEnabled()) return;

    if (e.type === 'touchstart'){
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
    }
    e.preventDefault();
    const controls = threeJsVariables.trackballControls;
    const zoomStep = settingsData.zoomButtonsStep;

    function timer() {
        if (e.target.classList.contains('disabled')){
            holdingOutButton(e);
            return;
        }
        // console.log("Timer tick:");
        switch (e.target.dataset.zoomBtn) {
            case 'decrease':
                !e.target.classList.contains('disabled') && controls.zoomCamera(zoomStep.decrease);
                break;
            case 'increase':
                !e.target.classList.contains('disabled') && controls.zoomCamera(zoomStep.increase);
                break;
        }

        setDisableToZoomButtons();

        timerID = requestAnimationFrame(timer);
    }

    requestAnimationFrame(timer);
}

function holdingOutButton(e) {
    // if (settingsData.tourIsActive) {
    //     stopCameraTour();
    //     return;
    // }
    if (e.type === 'touchmove'){
        const moveX = e.touches[0].clientX;
        const moveY = e.touches[0].clientY;

        if (Math.abs(touchStartX - moveX) > 20 || Math.abs(touchStartY - moveY) > 20){
            cancelAnimationFrame(timerID);
        }
    } else {
        cancelAnimationFrame(timerID);
    }
}

function zoomControlsHandler({target}) {
    // if (settingsData.tourIsActive) {
    //     stopCameraTour();
    //     return;
    // }

    if (userPrevent()){
        return;
    }

    if (projectMode.LiteMode.isActive() && projectMode.LiteMode.isVisible()){

        projectMode.LiteMode.zoomListener(target);
        return;
    }

    autoRotateTimerAction('update');

    const controls = threeJsVariables.trackballControls;
    const zoomStep = settingsData.zoomButtonsStep;

    switch (target.dataset.zoomBtn) {
        case 'decrease':
            !target.classList.contains('disabled') && controls.zoomCamera(zoomStep.decrease);
            break;
        case 'increase':
            !target.classList.contains('disabled') && controls.zoomCamera(zoomStep.increase);
            break;
    }

    setDisableToZoomButtons();
}

export async function fitModelInViewport(setDistance = false, model) {
    if (settingsData.buildingDestroyed) {
        return;
    }

    const zoomSettings = config.threejs.orbitControls.autoZoomSettings;
    if (!zoomSettings.activate) {
        return;
    }

    let size;

    if (model) {
        if (model.isVector3) {
            size = model;
        } else {
            const box = new Box3().setFromObject(model);
            size = box.getSize(new Vector3());
        }
    } else {
        size = await getTotalSizeOfBuildingAndSelectionBoxes();
    }

    let scalar;
    let foreshorteningZoomCorrection;
    let minZoomCorrection;

    // if (isMobile){
    //     if (settingsData.isLandscape){
    //         scalar = zoomSettings.mobile.landscape.scale;
    //         foreshorteningZoomCorrection = zoomSettings.mobile.landscape.foreshorteningZoomCorrection;
    //         minZoomCorrection = zoomSettings.mobile.landscape.minZoomCorrection;
    //     } else {
    //         scalar = zoomSettings.mobile.portrait.scale;
    //         foreshorteningZoomCorrection = zoomSettings.mobile.portrait.foreshorteningZoomCorrection;
    //         minZoomCorrection = zoomSettings.mobile.portrait.minZoomCorrection;
    //     }
    // } else {
    //     scalar = zoomSettings.desktop.scale;
    //     foreshorteningZoomCorrection = zoomSettings.desktop.foreshorteningZoomCorrection;
    //     minZoomCorrection = zoomSettings.desktop.minZoomCorrection;
    // }
    // size.multiplyScalar(scalar);

    const maxDim = Math.max(size.x, size.y, size.z);
    const h = size.y;
    const canvas = threeJsVariables.renderer.domElement;

    const cameraFov = threeJsVariables.perspectiveCamera.fov;
    const fovX = cameraFov * (canvas.clientWidth / canvas.clientHeight);
    const distanceX = (maxDim / 2) / Math.tan(Math.PI * fovX / 360) + (maxDim / 2);
    const distanceY = (h / 2) / Math.tan(Math.PI * cameraFov / 360) + (maxDim / 2);

    const distance = Math.max(distanceX, distanceY);

    zoomSettings.max = distance + maxDim * 2;
    zoomSettings.foreshortening = maxDim * 2;
    zoomSettings.min = maxDim;
    if (setDistance) {
        setMinAndMaxControlsDistance();
    }

    return {
        size,
        distance
    };
}

export function getObjectViewDistance (object,side = 'auto') {
    const box = new Box3().setFromObject(object);
    const size = new Vector3();
    box.getSize(size);

    function _distanceToFitObjectInView(size, fov) {
        return size / (2 * Math.tan(fov / 2))
    }

    const width = Math.max(size.x,size.z);
    const height = size.y;
    const objectAspect = width / height;
    const cameraFov = threeJsVariables.perspectiveCamera.fov;
    const cameraAspect = threeJsVariables.perspectiveCamera.aspect;
    const cameraHFov = Math.atan(cameraAspect * Math.tan(cameraFov / 2)) * 2;

    let distance = 0;

    switch (side) {
        case 'auto':
            if (objectAspect < cameraAspect) {
                distance = _distanceToFitObjectInView(height, cameraFov);
            } else {
                distance = _distanceToFitObjectInView(width, cameraHFov);
            }
            break;
        case 'width':
            distance = _distanceToFitObjectInView(width, cameraHFov);
            break;
        case 'height':
            distance = _distanceToFitObjectInView(height, cameraFov);
            break;
    }

    return distance;
}

export function getZoomParams () {
    const zoom = config.threejs.orbitControls.autoZoomSettings;
    return {
        min: zoom.min,
        max: zoom.max,
        foreshortening: zoom.foreshortening
    }
}

export function autoZoomIsActive () {
    return config.threejs.orbitControls.autoZoomSettings.activate;
}

export function getTotalSizeOfBuildingAndSelectionBoxes() {
    let buildings, sBoxes;
    return new Promise(resolve => {
        const checkModels = setInterval(() => {
            if (settingsData.activeViewMode !== 'orbit') {
                // const activeBuilding = buildings_info.find(building => building.isActive);
                const activeBuilding = Buildings.getActiveBuilding();
                buildings = threeJsVariables.scene.getObjectByName(activeBuilding.name);
                sBoxes = activeBuilding.selectionsGroup;
            } else {
                buildings = threeJsVariables.scene.getObjectByName('Project Buildings');
                sBoxes = getHighlights();// threeJsVariables.scene.getObjectByName('Project Selection Boxes');
                if (Array.isArray(sBoxes)) {
                    sBoxes = null;
                }
            }

            if (buildings && sBoxes) {
                clearInterval(checkModels);
                const buildingSize = new Box3().setFromObject(buildings).getSize(new Vector3());
                const sBoxSize = new Box3().setFromObject(sBoxes).getSize(new Vector3());
                const totalSize = new Vector3(buildingSize.x, sBoxSize.y, buildingSize.z);
                resolve(totalSize);
            } else if (!buildings && sBoxes){
                clearInterval(checkModels);
                const sBoxSize = new Box3().setFromObject(sBoxes).getSize(new Vector3());
                resolve(sBoxSize);
            } else if (!buildings && !sBoxes && settingsData.loadingError) {
                clearInterval(checkModels);
                resolve(new Vector3(40,40,40));
            }
        }, 100);
    });
}

export const setDisableToZoomButtons = () => {
  const currentZoom = getCurrentCameraDistance();
  const buttonIncrease = document.querySelector('.zoom__controls__btn.icon-plus');
  const buttonDecrease = document.querySelector('.zoom__controls__btn.icon-minus');

  if (!buttonIncrease || !buttonDecrease){
      return;
  }

  const minDistance = threeJsVariables.orbitControls.minDistance;
  const maxDistance = threeJsVariables.orbitControls.maxDistance;

    if (currentZoom >= maxDistance - 2) {
        !buttonDecrease.classList.contains('disabled') && buttonDecrease.classList.add('disabled');
    } else if (currentZoom <= minDistance + 2 ) {
        !buttonIncrease.classList.contains('disabled') && buttonIncrease.classList.add('disabled');
    } else {
        buttonIncrease.classList.contains('disabled') && buttonIncrease.classList.remove('disabled');
        buttonDecrease.classList.contains('disabled') && buttonDecrease.classList.remove('disabled');
    }
}
